import styled, { createGlobalStyle } from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import XButtonBase from "@streeteasy/design-system/deprecated/XButton";

import {
  ButtonContainer,
  CancelButton
} from "../ListingAgentContactForm/styled";
import ListingAgentDescriptionBase from "../ListingAgentDescription";

const { BRAND_DARKEST, WHITE } = colors;
const { LARGE_SCREEN } = screenSizes;

const modalPadding = "64px";
const modalPaddingMobile = "24px";
const modalPortalZindex = 1070; // Must be this big so we can override Premier Agent's mWeb modal

export const ModalPortalClassName = "ListingAgentContactDrawerPortal";

export const ModalPortalGlobalStyle = createGlobalStyle`
  .${ModalPortalClassName} {
    position: relative;
    z-index: ${modalPortalZindex};
  }
`;

export const ModalContent = styled.div`
  overflow: scroll;
  position: relative;
  width: 100%;

  ${ButtonContainer} {
    margin-left: -${modalPadding};
    margin-right: -${modalPadding};
    padding-left: ${modalPadding};
    padding-right: ${modalPadding};

    @media screen and (max-width: ${LARGE_SCREEN}px) {
      margin-left: -${modalPaddingMobile};
      margin-right: -${modalPaddingMobile};
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  ${CancelButton} {
    @media screen and (max-width: ${LARGE_SCREEN}px) {
      display: none;
    }
  }
`;

export const XButton = styled(XButtonBase)`
  position: absolute;
  right: 21px;
  top: 21px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    right: auto;
    left: 21px;

    &:after,
    &:before {
      background-color: ${WHITE};
    }
`;

export const FormContent = styled.div`
  padding: ${modalPadding} ${modalPadding} 0;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    padding: ${modalPaddingMobile} ${modalPaddingMobile} 0;
  }
`;

export const MessageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export const Title = styled(typography.H2)`
  margin-bottom: 24px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    align-items: center;
    background-color: ${BRAND_DARKEST};
    color: ${WHITE};
    display: flex;
    font-size: 16px;
    font-weight: 700;
    height: 57px;
    justify-content: center;
    line-height: 24px;
    margin: -${modalPaddingMobile} -${modalPaddingMobile} 24px -${modalPaddingMobile};
    position: absolute;
    width: 100%;
    z-index: 2;
  }
`;

export const ListingAgentDescription = styled(ListingAgentDescriptionBase)`
  margin-bottom: 24px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    margin-top: 60px;
  }
`;
